import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="assistant-progress" on the chat transcript.
//
// When the user submits a message via the composer (turbo:submit-end), we
// start a 30-second timer. If no new message has been appended via Turbo
// Streams within that window, we show a toast offering a refresh.
//
// The timer is cancelled as soon as a new child appears under the
// transcript element — meaning the broadcast landed, even if the assistant
// is still working.
export default class extends Controller {
  static values = { timeoutMs: { type: Number, default: 30000 } }

  connect() {
    this.boundSubmit = this.handleSubmit.bind(this)
    this.element.addEventListener("turbo:submit-end", this.boundSubmit)

    this.observer = new MutationObserver(() => {
      // Any DOM mutation under the transcript = broadcast landed.
      this.cancelTimer()
    })
    this.observer.observe(this.element, { childList: true, subtree: false })
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.boundSubmit)
    this.observer?.disconnect()
    this.cancelTimer()
  }

  handleSubmit() {
    this.cancelTimer()
    this.timer = setTimeout(() => this.showToast(), this.timeoutMsValue)
  }

  cancelTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  showToast() {
    if (document.getElementById("ai-drop-toast")) return
    const toast = document.createElement("div")
    toast.id = "ai-drop-toast"
    toast.setAttribute("role", "status")
    toast.style.cssText = "position:fixed;left:50%;bottom:1rem;transform:translateX(-50%);background:#1c1917;color:white;padding:0.6rem 1rem;border-radius:8px;font-size:13px;z-index:1000;display:flex;gap:0.5rem;align-items:center;box-shadow:0 4px 16px rgba(0,0,0,0.2)"
    toast.innerHTML = `
      <span>Still working… or did the connection drop?</span>
      <button type="button" style="background:transparent;border:1px solid rgba(255,255,255,0.4);color:white;padding:2px 8px;border-radius:6px;cursor:pointer">Refresh</button>
    `
    toast.querySelector("button").addEventListener("click", () => window.location.reload())
    document.body.appendChild(toast)
    setTimeout(() => toast.remove(), 12000)
  }
}
